import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  flightSearchAsync,
  getFlightSearched,
  getLoading,
  ResetLoader,
} from "../../../features/bookings/flightSlice";
import Loader from "../../../helpers/Loader";
import FlightList from "./FlightList";
import { Link, useSearchParams } from "react-router-dom";
import MainModal from "../../modals/MainModal";
import moment from "moment";
import FlightFilter from "../../common/filter/FlightFilter";
import { getLogin } from "../../../features/userSlice";

const Flight = () => {
  const [filterTimer, SetfilterTimer] = useState(0);
  // const loading = useSelector(getLoading);
  const FlightLoader = useSelector((state) => state.flight.flightListLoader);
  const flightSearched = useSelector(getFlightSearched);
  const [searchParams] = useSearchParams();
  const userDatas = useSelector(getLogin);
  const userData = JSON.parse(sessionStorage.getItem("userData")) || {};

  const [queryData, setQueryData] = useState(
    Object.fromEntries([...searchParams])
  );

  const [loader, setLoader] = useState(true);
  const [from, setFrom] = useState({});
  const [to, setTo] = useState({});
  const [show, setShow] = useState(false);
  const [modal, setModal] = useState("login");

  const [flightList, setFlightList] = useState([]);
  const [flightListBackup, setFlightListBackup] = useState([]);

  const [tripType, setTripType] = React.useState("1");
  const [airlineName, setAirlineName] = useState([]);
  const [oneWayOrigin, setOneWayOrigin] = useState();
  const [oneWayDestination, setOneWayDestination] = useState();

  const [maxPrice, setMaxPrice] = useState(0);
  const [minPrice, setMinPrice] = useState(0);
  const [respFilter, setRespFilter] = useState(false);
  const [previousLogin, setPreviousLogin] = useState(
    Object.keys(userData).length
  );
  const dispatch = useDispatch();

  useEffect(() => {
    console.log("FlightLoader", FlightLoader);
    if (FlightLoader) {
      setLoader(true);
    } else {
      setTimeout(() => {
        // setLoader(false);
      }, 800);
    }
  }, [FlightLoader]);

  useEffect(() => {
    if (Object.keys(userData).length > 0) {
      if (previousLogin === 0 && userData?.role === "Agent") {
        setPreviousLogin(1);
      }
    }

    setTimeout(() => {}, 2000);
  }, [userDatas]);

  useEffect(() => {
    setLoader(true);
    setQueryData(Object.fromEntries([...searchParams]));
    setTripType(Object.fromEntries([...searchParams])?.tripType);

    setFrom(JSON.parse(Object.fromEntries([...searchParams]).state).pickUp);
    setTo(JSON.parse(Object.fromEntries([...searchParams]).state).dropOff);

    const queryDatas = Object.fromEntries([...searchParams]);
    if (Object.keys(queryDatas).length > 0) {
      // dispatch(ResetLoader());

      const state = JSON.parse(queryDatas.state);
      // alert(1);
      const {
        adultsCount,
        childsCount,
        infantsCount,
        travelClass,
        tripType,
        directFlight,
      } = queryDatas || {};

      dispatch(
        flightSearchAsync({
          state,
          adultsCount,
          childsCount,
          infantsCount,
          travelClass,
          tripType,
          directFlight,
          Authorization: userData.Authorization,
        })
      );
      setLoader(true);
      setTripType(tripType);
    }
  }, [searchParams, previousLogin]);

  useEffect(() => {
    sessionStorage.setItem(
      "flightTrackingToken",
      JSON.stringify({
        flightTokenId: flightSearched.TokenId,
        flightTrackingId: flightSearched.TrackingId,
      })
    );
    setFlightList(
      flightSearched?.Results?.length > 0 ? flightSearched.Results[0] : []
    );
    setFlightListBackup(
      flightSearched?.Results?.length > 0 ? flightSearched.Results[0] : []
    );
    var airLineName = [];
    var MinPrices =
      flightSearched?.Results?.length > 0 &&
      Math.min(
        ...flightSearched?.Results?.[0].map(
          (price) => price["Fare"]["TotalFare"]
        )
      );
    var MaxPrices =
      flightSearched?.Results?.length > 0 &&
      Math.max(
        ...flightSearched?.Results?.[0].map(
          (price) => price["Fare"]["TotalFare"]
        )
      );

    setMaxPrice(MaxPrices);
    setMinPrice(MinPrices);

    flightSearched?.Results?.length > 0 &&
      flightSearched.Results[0].map((airlines) => {
        airlines?.["Segments"].map((val, i) => {
          const findss = airLineName.find((f) => f === val[0]["AirlineName"]);
          if (findss === undefined) {
            airLineName.push(val[0]["AirlineName"]);
          }
        });
      });
    setAirlineName(airLineName);

    if (tripType === "1") {
      var seg = flightSearched?.Results?.[0]?.[0]?.["Segments"]?.[0];

      var Origin = seg?.[0]?.["Origin"]?.["CityName"];
      var dest = seg?.[seg.length - 1]?.["Destination"]?.["CityName"];
    }
    setOneWayOrigin(Origin);
    setOneWayDestination(dest);
    if (Object.keys(flightSearched).length > 0) {
      console.log("flightSearched", flightSearched);
      setTimeout(() => {
        setLoader(false);
      }, 500);
    }
  }, [flightSearched]);

  const Filter = (data) => {
    const PriceSort = data["PriceSort"];
    const Airlines = data["Airlines"];
    const DepartureTime = data["DepatureTime"];
    const ArrivalTime = data["ArrivalTime"];
    const PriceRange = data["PriceRange"];
    const ReturnDepatureTime = data["ReturnDepatureTime"];
    const ReturnArrivalTime = data["ReturnArrivalTime"];
    const Reset = data["Reset"];

    var tempFlight = flightListBackup;

    var newarr = [];
    if (Airlines.length > 0) {
      var j = 0;
      tempFlight.map((airline, i) => {
        airline["Segments"].filter((name) => {
          if (Airlines.includes(name[0]["AirlineName"])) {
            newarr[j] = airline;
            j++;
          }
        });
      });
      tempFlight = newarr;
    }

    //DEPATURE TIME

    if (DepartureTime.length > 0) {
      var BeforeSix = [];
      var sixTotwelve = [];
      var twelveToSix = [];
      var AfterSix = [];
      if (DepartureTime.includes("0")) {
        var beforeSix = tempFlight.map((flight) => {
          if (moment(flight["Segments"][0][0].DepartureTime).hours() <= 5) {
            return flight;
          }

          if (
            moment(flight["Segments"][0][0].DepartureTime).hours() === 6 &&
            moment(flight["Segments"][0][0].DepartureTime).minute() == 0
          ) {
            return flight;
          }
        });
        beforeSix = beforeSix.filter((time) => time !== undefined);
        BeforeSix = beforeSix;
      }

      if (DepartureTime.includes("1")) {
        var sixTotwelves = tempFlight.map((flight) => {
          if (
            moment(flight["Segments"][0][0].DepartureTime).hours() >= 6 &&
            moment(flight["Segments"][0][0].DepartureTime).hours() <= 11
          ) {
            return flight;
          }

          if (
            moment(flight["Segments"][0][0].DepartureTime).hours() === 12 &&
            moment(flight["Segments"][0][0].DepartureTime).minute() == 0
          ) {
            return flight;
          }
        });
        sixTotwelves = sixTotwelves.filter((time) => time !== undefined);
        sixTotwelve = sixTotwelves;
      }

      if (DepartureTime.includes("2")) {
        var twelveToSixs = tempFlight.map((flight) => {
          if (
            moment(flight["Segments"][0][0].DepartureTime).hours() >= 12 &&
            moment(flight["Segments"][0][0].DepartureTime).hours() <= 17
          ) {
            return flight;
          }

          if (
            moment(flight["Segments"][0][0].DepartureTime).hours() === 18 &&
            moment(flight["Segments"][0][0].DepartureTime).minute() == 0
          ) {
            return flight;
          }
        });
        twelveToSixs = twelveToSixs.filter((time) => time !== undefined);
        twelveToSix = twelveToSixs;
      }

      if (DepartureTime.includes("3")) {
        var AfterSixs = tempFlight.map((flight) => {
          if (moment(flight["Segments"][0][0].DepartureTime).hours() >= 18) {
            return flight;
          }
        });
        AfterSixs = AfterSixs.filter((time) => time !== undefined);
        AfterSix = AfterSixs;
      }
      tempFlight = [...BeforeSix, ...sixTotwelve, ...twelveToSix, ...AfterSix];
    }
    // p["Vehicles"][0]["Price"]["TotalPrice"] >= PriceRange[0] &&
    // p["Vehicles"][0]["Price"]["TotalPrice"] <= PriceRange[1]

    //ARRIVAL TIME

    if (ArrivalTime.length > 0) {
      var BeforeSix = [];
      var sixTotwelve = [];
      var twelveToSix = [];
      var AfterSix = [];

      if (ArrivalTime.includes("0")) {
        var beforeSix = tempFlight.map((flight) => {
          if (
            moment(
              flight["Segments"][0][flight["Segments"][0].length - 1]
                .ArrivalTime
            ).hours() <= 5
          ) {
            return flight;
          }

          if (
            moment(
              flight["Segments"][0][flight["Segments"][0].length - 1]
                .ArrivalTime
            ).hours() === 6 &&
            moment(
              flight["Segments"][0][flight["Segments"][0].length - 1]
                .ArrivalTime
            ).minute() == 0
          ) {
            return flight;
          }
        });
        beforeSix = beforeSix.filter((time) => time !== undefined);
        BeforeSix = beforeSix;
      }
      if (ArrivalTime.includes("1")) {
        var sixTotwelves = tempFlight.map((flight) => {
          if (
            moment(
              flight["Segments"][0][flight["Segments"][0].length - 1]
                .ArrivalTime
            ).hours() >= 6 &&
            moment(
              flight["Segments"][0][flight["Segments"][0].length - 1]
                .ArrivalTime
            ).hours() <= 11
          ) {
            return flight;
          }

          if (
            moment(
              flight["Segments"][0][flight["Segments"][0].length - 1]
                .ArrivalTime
            ).hours() === 12 &&
            moment(
              flight["Segments"][0][flight["Segments"][0].length - 1]
                .ArrivalTime
            ).minute() == 0
          ) {
            return flight;
          }
        });
        sixTotwelves = sixTotwelves.filter((time) => time !== undefined);
        sixTotwelve = sixTotwelves;
      }

      if (ArrivalTime.includes("2")) {
        var twelveToSixs = tempFlight.map((flight) => {
          if (
            moment(
              flight["Segments"][0][flight["Segments"][0].length - 1]
                .ArrivalTime
            ).hours() >= 6 &&
            moment(
              flight["Segments"][0][flight["Segments"][0].length - 1]
                .ArrivalTime
            ).hours() <= 11
          ) {
            return flight;
          }

          if (
            moment(
              flight["Segments"][0][flight["Segments"][0].length - 1]
                .ArrivalTime
            ).hours() === 12 &&
            moment(
              flight["Segments"][0][flight["Segments"][0].length - 1]
                .ArrivalTime
            ).minute() == 0
          ) {
            return flight;
          }
        });
        twelveToSixs = twelveToSixs.filter((time) => time !== undefined);
        twelveToSix = twelveToSixs;
      }

      if (ArrivalTime.includes("3")) {
        var twelveToSixs = tempFlight.map((flight) => {
          if (
            moment(
              flight["Segments"][0][flight["Segments"][0].length - 1]
                .ArrivalTime
            ).hours() >= 6 &&
            moment(
              flight["Segments"][0][flight["Segments"][0].length - 1]
                .ArrivalTime
            ).hours() <= 11
          ) {
            return flight;
          }

          if (
            moment(
              flight["Segments"][0][flight["Segments"][0].length - 1]
                .ArrivalTime
            ).hours() === 12 &&
            moment(
              flight["Segments"][0][flight["Segments"][0].length - 1]
                .ArrivalTime
            ).minute() == 0
          ) {
            return flight;
          }
        });
        twelveToSixs = twelveToSixs.filter((time) => time !== undefined);
        twelveToSix = twelveToSixs;
      }

      tempFlight = [...BeforeSix, ...sixTotwelve, ...twelveToSix, ...AfterSix];
    }

    //RETURN DEPATURE TIME
    if (ReturnDepatureTime.length > 0) {
      var BeforeSix = [];
      var sixTotwelve = [];
      var twelveToSix = [];
      var AfterSix = [];
      if (ReturnDepatureTime.includes("0")) {
        var beforeSix = tempFlight.map((flight) => {
          if (moment(flight["Segments"][1][0].DepartureTime).hours() <= 5) {
            return flight;
          }

          if (
            moment(flight["Segments"][1][0].DepartureTime).hours() === 6 &&
            moment(flight["Segments"][1][0].DepartureTime).minute() == 0
          ) {
            return flight;
          }
        });
        beforeSix = beforeSix.filter((time) => time !== undefined);
        BeforeSix = beforeSix;
      }

      if (ReturnDepatureTime.includes("1")) {
        var sixTotwelves = tempFlight.map((flight) => {
          if (
            moment(flight["Segments"][1][0].DepartureTime).hours() >= 6 &&
            moment(flight["Segments"][1][0].DepartureTime).hours() <= 11
          ) {
            return flight;
          }

          if (
            moment(flight["Segments"][1][0].DepartureTime).hours() === 12 &&
            moment(flight["Segments"][1][0].DepartureTime).minute() == 0
          ) {
            return flight;
          }
        });
        sixTotwelves = sixTotwelves.filter((time) => time !== undefined);
        sixTotwelve = sixTotwelves;
      }

      if (ReturnDepatureTime.includes("2")) {
        var twelveToSixs = tempFlight.map((flight) => {
          if (
            moment(flight["Segments"][1][0].DepartureTime).hours() >= 12 &&
            moment(flight["Segments"][1][0].DepartureTime).hours() <= 17
          ) {
            return flight;
          }

          if (
            moment(flight["Segments"][1][0].DepartureTime).hours() === 18 &&
            moment(flight["Segments"][1][0].DepartureTime).minute() == 0
          ) {
            return flight;
          }
        });
        twelveToSixs = twelveToSixs.filter((time) => time !== undefined);
        twelveToSix = twelveToSixs;
      }

      if (ReturnDepatureTime.includes("3")) {
        var AfterSixs = tempFlight.map((flight) => {
          if (moment(flight["Segments"][1][0].DepartureTime).hours() >= 18) {
            return flight;
          }
        });
        AfterSixs = AfterSixs.filter((time) => time !== undefined);
        AfterSix = AfterSixs;
      }
      tempFlight = [...BeforeSix, ...sixTotwelve, ...twelveToSix, ...AfterSix];
    }

    //RETURN ARRIVAL TIME
    if (ReturnArrivalTime.length > 0) {
      var BeforeSix = [];
      var sixTotwelve = [];
      var twelveToSix = [];
      var AfterSix = [];

      if (ReturnArrivalTime.includes("0")) {
        var beforeSix = tempFlight.map((flight) => {
          if (
            moment(
              flight["Segments"][1][flight["Segments"][1].length - 1]
                .ArrivalTime
            ).hours() <= 5
          ) {
            return flight;
          }

          if (
            moment(
              flight["Segments"][1][flight["Segments"][1].length - 1]
                .ArrivalTime
            ).hours() === 6 &&
            moment(
              flight["Segments"][1][flight["Segments"][1].length - 1]
                .ArrivalTime
            ).minute() == 0
          ) {
            return flight;
          }
        });
        beforeSix = beforeSix.filter((time) => time !== undefined);
        BeforeSix = beforeSix;
      }
      if (ReturnArrivalTime.includes("1")) {
        var sixTotwelves = tempFlight.map((flight) => {
          if (
            moment(
              flight["Segments"][1][flight["Segments"][1].length - 1]
                .ArrivalTime
            ).hours() >= 6 &&
            moment(
              flight["Segments"][1][flight["Segments"][1].length - 1]
                .ArrivalTime
            ).hours() <= 11
          ) {
            return flight;
          }

          if (
            moment(
              flight["Segments"][1][flight["Segments"][1].length - 1]
                .ArrivalTime
            ).hours() === 12 &&
            moment(
              flight["Segments"][1][flight["Segments"][1].length - 1]
                .ArrivalTime
            ).minute() == 0
          ) {
            return flight;
          }
        });
        sixTotwelves = sixTotwelves.filter((time) => time !== undefined);
        sixTotwelve = sixTotwelves;
      }

      if (ReturnArrivalTime.includes("2")) {
        var twelveToSixs = tempFlight.map((flight) => {
          if (
            moment(
              flight["Segments"][1][flight["Segments"][1].length - 1]
                .ArrivalTime
            ).hours() >= 6 &&
            moment(
              flight["Segments"][1][flight["Segments"][1].length - 1]
                .ArrivalTime
            ).hours() <= 11
          ) {
            return flight;
          }

          if (
            moment(
              flight["Segments"][1][flight["Segments"][1].length - 1]
                .ArrivalTime
            ).hours() === 12 &&
            moment(
              flight["Segments"][1][flight["Segments"][1].length - 1]
                .ArrivalTime
            ).minute() == 0
          ) {
            return flight;
          }
        });
        twelveToSixs = twelveToSixs.filter((time) => time !== undefined);
        twelveToSix = twelveToSixs;
      }

      if (ReturnArrivalTime.includes("3")) {
        var twelveToSixs = tempFlight.map((flight) => {
          if (
            moment(
              flight["Segments"][1][flight["Segments"][1].length - 1]
                .ArrivalTime
            ).hours() >= 6 &&
            moment(
              flight["Segments"][1][flight["Segments"][1].length - 1]
                .ArrivalTime
            ).hours() <= 11
          ) {
            return flight;
          }

          if (
            moment(
              flight["Segments"][1][flight["Segments"][1].length - 1]
                .ArrivalTime
            ).hours() === 12 &&
            moment(
              flight["Segments"][1][flight["Segments"][1].length - 1]
                .ArrivalTime
            ).minute() == 0
          ) {
            return flight;
          }
        });
        twelveToSixs = twelveToSixs.filter((time) => time !== undefined);
        twelveToSix = twelveToSixs;
      }

      tempFlight = [...BeforeSix, ...sixTotwelve, ...twelveToSix, ...AfterSix];
    }

    if (PriceSort !== undefined) {
      if (PriceSort[0] === "MaxToMin") {
        tempFlight = [
          ...tempFlight
            .slice()
            .sort(
              (a, b) =>
                parseFloat(a["Fare"]["TotalFare"]) -
                parseFloat(b["Fare"]["TotalFare"])
            ),
        ];
      }
      if (PriceSort[0] === "MaxToMin") {
        tempFlight = [
          ...tempFlight.sort(
            (a, b) =>
              parseFloat(b["Fare"]["TotalFare"]) -
              parseFloat(a["Fare"]["TotalFare"])
          ),
        ];
      }
    }

    //PRICE RANGE
    if (PriceRange.length > 0) {
      tempFlight = tempFlight.filter(
        (p) =>
          p["Fare"]["TotalFare"] >= PriceRange[0] &&
          p["Fare"]["TotalFare"] <= PriceRange[1]
      );
    }

    if (Reset === true || Reset === "true") {
      tempFlight = flightListBackup;
      setMaxPrice("");
      setMinPrice("");
      setTimeout(() => {
        setMaxPrice(maxPrice);
        setMinPrice(0);
      }, 300);

      // setResetFilter(true);
      //RESET
      // HotelListingHandler();
    }

    setFlightList(tempFlight);
  };

  const resFilterNavigation = (type) => {
    if (type === "open") {
      setRespFilter(true);
    } else {
      setRespFilter(false);
    }
  };

  return (
    <>
      <section className="hotel-listing-main">
        <div className="container">
          <div
            className={
              respFilter ? "filter-backdrop active" : "filter-backdrop"
            }
            onClick={() => resFilterNavigation("close")}
          ></div>
          <div
            className={
              respFilter ? "navigation navigation-active" : "navigation"
            }
          >
            <FlightFilter
              FlightName={airlineName !== undefined && airlineName}
              oneWayOrigin={oneWayOrigin}
              oneWayDestination={oneWayDestination}
              returnOrigin={oneWayDestination}
              returnDestination={oneWayOrigin}
              tripType={tripType}
              minp={minPrice}
              maxp={maxPrice}
              filterTimer={filterTimer}
              setFilter={SetfilterTimer}
              filterData={(data) => {
                Filter(data);
              }}
            />
          </div>
          <div className="row">
            <div className="col-xl-3 for-desktop-screen">
              <FlightFilter
                FlightName={airlineName !== undefined && airlineName}
                oneWayOrigin={oneWayOrigin}
                oneWayDestination={oneWayDestination}
                returnOrigin={oneWayDestination}
                returnDestination={oneWayOrigin}
                tripType={tripType}
                minp={minPrice}
                maxp={maxPrice}
                filterTimer={filterTimer}
                setFilter={SetfilterTimer}
                filterData={(data) => {
                  Filter(data);
                }}
              />
            </div>
            <div className="col-xl-9 mt-4 position-relative">
              <div className="responsive-sidebar">
                <div>
                  <div
                    className="nav-btn"
                    onClick={() => resFilterNavigation("open")}
                  >
                    <img
                      src="assets/images/filter-icon.svg"
                      className="filter-icon"
                      alt="filter-icon"
                    />
                  </div>
                </div>
                <div className="flight-breadcrumb">
                  <div aria-label="breadcrumb">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item">
                        <Link to={"/"}>Home</Link>
                      </li>
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                      >
                        Flight Listing
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
              {console.log({ loader })}
              {loader ? (
                <>
                  <section class="overflow-hidden">
                    <div class="container-fluid">
                      <div class="row">
                        <div class="col-lg-12 p-0">
                          <div class="aeroplane-animation-wrap position-relative">
                            <div class="cloud-wrap">
                              <img
                                src="./assets/images/flight/cloud1.png"
                                class="cloud1"
                                alt=""
                              />
                            </div>
                            <div class="cloud-wrap2">
                              <img
                                src="./assets/images/flight/cloud2.png"
                                class="cloud2"
                                alt=""
                              />
                            </div>
                            <div class="aeroplane-img">
                              <img
                                src="./assets/images/flight/aeroplane.svg"
                                alt="aeroplane"
                              />
                            </div>
                            <div class="animation"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>

                  <div class="hotel-listing-wrap gray-border">
                    <div class="row justify-content-between align-items-center w-100">
                      <div class="col-lg-3">
                        <div class="">
                          <span class="loader-bg pt-4 mb-1 d-inline-block w-50 me-2 rounded"></span>
                          <span class="loader-bg p-3 mb-1 d-inline-block w-100 rounded"></span>
                          <span class="loader-bg pt-4 mb-1 d-inline-block w-50 me-2 rounded"></span>
                          <span class="loader-bg p-3 mb-1 d-inline-block w-100 rounded"></span>
                        </div>
                      </div>
                      <div class="col-lg-2">
                        <h4 class="loader-bg pt-4 mb-2"></h4>
                        <div class="loader-bg pt-4 mb-2"></div>
                      </div>
                      <div class="col-lg-3">
                        <div class="">
                          <span class="loader-bg pt-4 mb-1 d-inline-block w-50 me-2 rounded"></span>
                          <span class="loader-bg p-3 mb-1 d-inline-block w-100 rounded"></span>
                          <span class="loader-bg pt-4 mb-1 d-inline-block w-50 me-2 rounded"></span>
                        </div>
                      </div>
                      <div class="col-lg-3">
                        <span class="loader-bg pt-4 mb-1 d-inline-block w-50 me-2 rounded"></span>
                        <span class="loader-bg p-4 mb-1 d-inline-block w-100 rounded"></span>
                      </div>
                    </div>
                  </div>
                </>
              ) : flightList.length > 0 ? (
                flightList.map((ele, ind) => {
                  return (
                    <FlightList
                      tripType={tripType}
                      val={ele}
                      ind={ind}
                      key={ind}
                      pickUp={from}
                      dropOff={to}
                      setModal={setModal}
                      setShow={setShow}
                    />
                  );
                })
              ) : (
                <div className="transfer-wrap">
                  <div className="row align-items-center">
                    <div className="col-lg-3">
                      <div className="car-rental-image-wrap">
                        <img src="/assets/images/flight/no-fligts.svg" alt="" />
                      </div>
                    </div>
                    <div className="col-lg-9">
                      <div className="transfer-inner no-cars-wrap">
                        <h4 className="bold20">
                          Looks empty, you've no Flights Availabless
                        </h4>
                        <p>Please modify your search for more Flights</p>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
      {show ? (
        <MainModal
          modal={modal}
          setShow={setShow}
          show={show}
          setModal={setModal}
          // extraData={val.DayRates[0]}
        />
      ) : null}
    </>
  );
};

export default Flight;
